<template>
  <b-overlay :show="loading || reserving">
    <div class="ml-2 font-weight-bold">
      <b-link v-if="!inLobby" to="/webinars"><b-icon icon="chevron-left"></b-icon> All Upcoming Live Webinars</b-link>
      <b-link v-if="inLobby" @click="inLobby = false"><b-icon icon="chevron-left"></b-icon> Return to Classroom</b-link>
    </div>
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">{{errorMsg}}</b-alert>

          <div v-if="!error">

            <template v-if="!privacyOptinShow">
              <div class="div-section-header">
                <b-row>
                  <b-col cols="12" class="text-center">
                    <countdown v-if="!loading" :serverTime="getServerTime" :endTime="getReleaseDate" :alarmSeconds="alarmSeconds" @countdown-started="countdownStarted" @countdown-alarm="countdownAlarm"></countdown>
                  </b-col>
                </b-row>

                <div v-if="!loading && !reserving">
                  <b-row v-if="!studentData.isWaiting">
                    <b-col class="mt-3 mb-1 text-center">

                      <b-overlay :show="starting || !isCountdownStarted" rounded="sm">
                        <b-button v-if="started" :disabled="btnWebinarDisabled" :variant="btnWebinarVariant" class="mt-2" @click.prevent="classStart">Enter Webinar</b-button>
                        <b-button v-if="!started && !inLobby && isCountdownStarted" variant="success" class="mt-2" @click.prevent="inLobby=true">Enter Lobby</b-button>
                      </b-overlay>

                      <div class="mt-2" v-if="!inLobby">
                        <ul class="text-left" style="font-size: .75rem;">
                          <li>The Enter Webinar button will become visible within 5 minutes of the scheduled starting time.</li>
                          <li>This webinar requires the Zoom application. If you don't have Zoom installed, you will be prompted to download it after clicking Enter Webinar.</li>
                          <li>Download and installation takes less than 30 seconds. You will only need to do this one time</li>
                        </ul>
                      </div>

                      <b-button class="mt-2" :href="icalCalendar" variant="outline-primary" size="sm" v-if="!inLobby">
                        <b-icon icon="calendar-plus" aria-hidden="true"></b-icon>&nbsp;
                        Add Event to Calendar
                      </b-button>
                      <!-- <div class="calendar-webinar" style="text-align: center;">Add To Calendar</div>
                      <div style="text-align: center; margin-bottom: 15px;">
                        <a :href="googleCalendarUrl()" class="cal-google" title="Add to Google Calendar" target="_blank"><img style="height:22px;padding-left: 4px;" src="@/art/icon-google-t5.svg"></a>
                        <a :href="icalCalendar" class="cal-apple" title="Add to Apple iCal"><img style="height:25px;padding-left: 4px;" src="@/art/icon-apple-t5.svg"></a>
                        <a :href="icalCalendar" class="cal-outlook" title="Add to Outlook Calendar"><img style="height:22px;" src="@/art/icon-outlookcom-t5.svg"></a>
                      </div> -->

                    </b-col>
                  </b-row>
                  <b-card v-if="studentData.isWaiting" class="text-center mt-3 mb-1" style="background-color: #FFD;">
                      <b-button variant="info" @click="reloadPage">On Waitlist</b-button>
                      <div class="mt-2 text-left">
                          This class is full and you are on the waitlist.  If you received an email that you've been added to the class, click the button to update your status.
                      </div>
                  </b-card>
                </div>
              </div>

              <div class="div-section-body div-padding"  v-if="!inLobby">
                <b-row>
                  <b-col cols="4">
                      <b-img fluid v-bind:src="classObj.photo" />
                  </b-col>
                  <b-col cols="8" style="margin-left: -20px;">
                    <div class="class-title">{{classObj.className}}</div>
                    <div class="class-details">
                        {{classObj.name}}
                        <br />
                        Sponsor: {{classObj.companyName}}
                        <br>
                        {{classObj.credits}} CEU (Live, Interactive)
                        <br />
                        <span class="red">{{classObj.releaseDate | prettyDateTime}}</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- :inner-html.prop instead of v-html -->
                  <b-col class="txt-class-blurb mt-2" :inner-html.prop="this.classObj.description | nl2br"></b-col>
                </b-row>
              </div>

              <template v-if="inLobby">
                <lobby-webinar :ch="classObj.hash" :sh="studentHash"></lobby-webinar>
              </template>
            </template>

            <template v-if="privacyOptinShow">

              <b-card
                :title="privacyBlock.title"
                class="mt-2"
                style="border: 1px solid silver;"
              >
                  <b-card-text>
                    <div v-html="privacyBlock.blurb"></div>
                  </b-card-text>

                  <b-button id="popover-learnmore" variant="link">What does this mean?</b-button>
                  <b-popover
                    target="popover-learnmore"
                    placement="left"
                    triggers="hover focus"
                    style="min-width: 600px;"
                  >
                  <template #title>What does this mean?</template>
                  <div :inner-html.prop="privacyBlock.learnmore | nl2br"></div>
                </b-popover>

                <div class="text-center mt-2">
                   <b-button @click="setOptin" size="lg" variant="primary" class="mr-2">Yes</b-button>
                   <b-button @click="cancelOptin" size="lg" variant="outline-primary" class="ml-2">No</b-button>
                </div>

              </b-card>

            </template>

          </div>  <!-- !error -->

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import Countdown from "@/components/Countdown"
import constants from "@/config/constants"

const SECONDS_TO_ACTIVATE_WEBINAR = 60*5  // 60 seconds * 5 minutes (formerly 30)

export default {
  name: "ClassroomLive",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: 'No class selected.',
      loading: true,
      reserving: false,
      busy: false,
      alarmSeconds: SECONDS_TO_ACTIVATE_WEBINAR,
      msg: "Classroom",
      blurb: "Classroom blurb.",
      classObj: { status: false, zoomCode: null},
      studentData: {status: false, isWaiting: false, attendeeId: 0, gradebookId: 0},
      studentHash: this.$root.getToken(),
      classHash: "",
      starting: false,    // set to true when student is entering webinar
      started: false,     // set true when Enter Webinar button is active
      inLobby: false,     // set true when student is in Webinar Lobbby
      isCountdownStarted: false,  // set true when countdown object is tracking webinar start
      timer: null,     // polls class status
      privacyBlockTest: { status: true
        , title: 'Philips Oral Healthcare Contact Permission'
        , blurb: 'I would like to receive marketing related electronic communications about Philips products services, events and promotions that may be relevant to me based on my user preferences and behavior. I can revoke my consent at any time.'
        , learnmore: 'At Philips we have a longstanding commitment to respect the privacy of our consumers, customers and other individuals we deal with, such as patients. To live up to this commitment, we have adopted and implemented a set of Binding Corporate Rules (known as Philips Privacy Rules) which define how we adequately process personal data throughout the Philips group, both in our capacity as Controller and as Processor. We also rely on our Binding Corporate Rules when transferring personal data between Philips group companies worldwide. In fact, we were one of the first companies in Europe to have received the approval of the competent data protection authorities of the European Union for our Binding Corporate Rules. The Philips Privacy Rules (Controller) define, for example, under which legal basis we legitimately process personal data, what are the envisaged criteria to retain personal data (before erasure) or when to provide privacy notices to the relevant individuals.'
      },
      privacyBlock: { status: true
        , title: null
        , blurb: null
        , learnmore: null
      },
      privacyOptinShow: false
    }
  },
  components: {
    'countdown': Countdown
  },
  props: {
    // route set to use props mapped to url parameters
    c: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    getServerTime() {
      return this.classObj.serverTime
    },
    getReleaseDate() {
      return this.classObj.releaseDateUTC
    },
    btnWebinarDisabled() {
      let aout = this.classObj.zoomCode === null || !this.started
      if (this.debug) console.log(`btnWebinarDisabled: ${aout} zoom: ${this.classObj.zoomCode} started: ${this.started}`)
      return aout
    },
    btnWebinarVariant() {
      let aout = (this.classObj.zoomCode !== null && this.started) ? 'success' : 'secondary'
      if (this.debug) console.log(`btnWebinarVariant: ${aout} zoom: ${this.classObj.zoomCode} started: ${this.started}`)
      return aout
    },
    zoomUrl() {
      let url = `https://zoom.us/j/${this.classObj.zoomCode}`
      return url
    },
    icalCalendar() {
      let url = `${this.getDesktopUrl}/member/calendarAdd.asp?type=ical&h=${this.classObj.hash}`
      return url
    },
    getDesktopUrl() {
        // Defined in main.js
        return this.$desktopUrl
    },
    canShowLobby() {
      // Returns true when Enter Lobby button can be visible.
      return !this.started && !this.inLobby
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    countdownAlarm() {
      if (this.debug) console.log(`Event: countdown-alarm`)
      this.scrollToTop()
      this.started = true   // turn on Enter Webinar button
      this.inLobby = false  // turn off lobby
    },
    countdownStarted() {
      if (this.debug) console.log(`Event: countdown-started`)
      this.isCountdownStarted = true   // turn on button section; either Enter Webinar or Enter Lobby
    },
    scrollToTop() {
      window.scrollTo(0,0)
    },
    googleCalendarUrl() {
      var aout, url, subject, msg
      var startDateZ, endDateZ, startDate, endDate

      url = `${this.getDesktopUrl}/member/classroom.asp?x_classId=${this.classObj.classId}`
      subject = "Live CE Webinar: Viva Learning"
      msg = `${this.classObj.className} by ${this.classObj.name}\n${url}`

      startDate = new Date(this.classObj.releaseDate)

      // Add the durationMin to get class end time.  Keep on 2 lines
      endDate = new Date(startDate.getTime())
      endDate.setMinutes(startDate.getMinutes() + this.classObj.durationMin)

      // YYYYMMNN T HHMMSS Z   <-- T and Z are literals
      startDateZ = utils.getDateTimeZ(startDate)  // "20210205T2300Z"
      endDateZ = utils.getDateTimeZ(endDate)	// "20210205T2330Z"

      aout = "https://calendar.google.com/calendar/r/eventedit"
        + "?text=" + subject
        + "&dates=" + startDateZ +"/" + endDateZ
        + "&details=" + encodeURI(msg)
        + "&location=" + encodeURI(url)

      // console.log(`aout: ${aout}`)
      return aout
    },
    reloadPage() {
      this.getClass()
    },
    reserveSeat() {
      if (this.debug) console.log(`Reserving seat: ${this.classHash}`)
      this.reserving = true
      service
        .reserveSeat(this.classHash, this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
                // this.$router.push(`/live/${this.classHash}`)
                this.studentData.status = res.status
                this.studentData.attendeeId = res.attendeeId
                this.studentData.isWaiting = res.isWaiting
                if ( res.hasOwnProperty('privacyBlock') && res.privacyBlock.status) {
                  // Display privacy block.
                  this.privacyBlock = res.privacyBlock
                  this.privacyOptinShow = true
                }
            }
            else {
              this.error = true
              this.errorMsg = "Unable to reserve seat."
            }
          }).bind(this)
        )
        .finally(e => {
          this.reserving = false
        })
        .catch(e => {
          this.error = true
          this.errorMsg = "Error trapped while reserving seat."
          console.log(e);
        })
    },
    setOptin() {
      let optinFlag = true
      if (this.debug) console.log(`setOptin: ${this.classHash}   ${optinFlag}`)
      this.reserving = true
      service
        .setOptin(this.classHash, this.studentHash, optinFlag)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
              this.privacyOptinShow = false
            }
            else {
              this.error = true
              this.errorMsg = "Unable to record optin."
            }
          }).bind(this)
        )
        .finally(e => {
          this.reserving = false
        })
        .catch(e => {
          this.error = true
          this.errorMsg = "Error trapped while recording optin."
          console.log(e);
        })
    },
    cancelOptin() {
      this.privacyOptinShow = false
    },
    classStart() {
      if (this.debug) console.log(`Class start: ${this.classHash}`)
      this.starting = true
      service
        .classStart(this.classHash, this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
                this.studentData.status = res.status
                this.studentData.attendeeId = res.attendeeId
                this.studentData.gradebookId = res.gradebookId
                // let zoom = window.open(this.zoomUrl, '_blank')
                // if (zoom) zoom.focus()
                window.location.assign(this.zoomUrl)
            }
            else {
              this.error = true
              this.errorMsg = "Error classStart service."
            }
          }).bind(this)
        )
        .finally(e => {
          this.starting = false
        })
        .catch(e => {
          this.error = true
          this.errorMsg = "Trapped error: classStart"
          console.log(e)
        })
    },
    getClass() {  // recalled via setInterval() - forwards to /classroom on class end.
      if (this.busy) return   // still servicing call.
      this.busy = true
      service
        .getClass(this.classHash, this.studentHash)
        .then(
          (data => {
            if (this.debug) console.log(data)
            if (data.status) {
              this.classObj = data.classObj
              if (this.classObj.typeId != constants.CLASS_TYPE.LIVE) {
                // Class not live head over to archive classroom.
                this.$router.push(`/classroom/${this.classObj.hash}`)
              }
              if (this.classObj.zoomCode === null) { console.log(`ALERT: null zoom code!`)}

              this.studentData = data.studentData
              this.studentData.status = data.status
              if (this.debug) console.log(`Back from getClass attendeeId: ${this.studentData.attendeeId}`)
              if (this.studentData.attendeeId === 0) {
                // Reserve seat for student.
                this.reserveSeat()
              }
            }
            else {
              this.error = true
              this.errorMsg = "Service error: getClass."
            }
          }).bind(this)
        )
        .finally(e => {
          this.busy = false
          this.loading = false
        })
        .catch(e => {
          this.error = true
          this.errorMsg = "Trapped error: getClass service."
          // ?? Cancel timer?  Ask to refresh page.  What if lost internet access?
          console.log(e)
        })
    }
  },
  created() {
    this.classHash = this.c || this.$route.query.c || this.$root.getClassHash() || null
    if (this.classHash) {
      this.loading = true
      this.getClass()
      if (!this.error) {
        // Page polls service to detect class start.
        this.timer = window.setInterval(this.reloadPage.bind(this), 15000)  // 15 seconds
      }
    }
    else {
      this.$router.push("/exams")   // CE in progress
    }
  },
  mounted () {
    if (this.debug) console.log('ClassroomLive mounted')
  },
  beforeDestroy() {
    this.classObj = {status: false, zoomCode: null}
    this.studentData = {status: false, isWaiting: false, attendeeId: 0, gradebookId: 0}
    this.error = false
    this.privacyOptinShow = false
    if (this.timer) window.clearInterval(this.timer)
    this.timer = null
    // this.loading = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

		.calendar-webinar{
			text-align: center;
			margin: 15px;
			font-weight: 600;
			font-size: 12px;
		}
		.cal-google {
			cursor: pointer !important;
		}
		.cal-apple {
			padding-left: 8px;
			cursor: pointer !important;
		}

		.cal-outlook {
			color: #3b5998 !important;
			cursor: pointer !important;
			padding-left: 12px;
		}

		.cal-icon-apple {
    		background: url(/art/icon-apple-t5.svg) 18px 40% no-repeat;
    		background-size: 22px 100%;
			padding-left: 8px;
		}
		.cal-icon-google {
			background: url(/art/icon-google-t5.svg) 18px 50% no-repeat;
			background-size: 22px 100%;
			padding-left: 8px;
		}
		.cal-icon-outlook {
			background: url(/art/icon-office365-t5.svg) 19px 50% no-repeat;
			background-size: 18px 100%;
		}

</style>



// WEBPACK FOOTER //
// src/components/ClassroomLive.vue